/* eslint-disable @typescript-eslint/naming-convention */
import { Mass } from 'src/api';

export const massConfig: Mass = {
  config_type: Mass.config_type.MASS,
};
